'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Date = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Date, _Component);

  function Date() {
    (0, _classCallCheck3.default)(this, Date);
    return (0, _possibleConstructorReturn3.default)(this, (Date.__proto__ || (0, _getPrototypeOf2.default)(Date)).apply(this, arguments));
  }

  (0, _createClass3.default)(Date, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          time = _props.time,
          fullDate = _props.fullDate;


      return _react2.default.createElement(
        'span',
        { title: (0, _moment2.default)(time).format('lll') },
        fullDate ? (0, _moment2.default)(time).calendar() : (0, _moment2.default)(time).fromNow()
      );
    }
  }]);
  return Date;
}(_react.Component), _class.propTypes = {
  time: _react.PropTypes.string,
  fullDate: _react.PropTypes.bool
}, _temp);
exports.default = Date;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DateText/DateText.js
 ** module id = 1382
 ** module chunks = 0
 **/